/**
 * Minimum password complexity:
 * At least 8 characters; including:
 * * At least 1 number
 * * At least 1 Uppercase letter
 * 
 * \S: Any non-whitespace character (space, tab, newline)
 * 
 */

// TODO: explain each part of regex
// min password length: 8
// max password length: 128
// TODO: this should be in 
export const passwordComplexityRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,128}$/

export const phoneNumberRegex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const deleteRegex = /\b(DELETE)\b/